import { Star, MapPin, Clock, CheckCircle2, Search, MessageCircle } from "lucide-react";

const PROVIDERS = [
    { name: "Ravi's Plumbing", tag: "Plumbing", rating: "4.9", jobs: 212, response: "~10 min", color: "bg-blue-500" },
    { name: "Spark Electric YYC", tag: "Electrical", rating: "4.8", jobs: 167, response: "~15 min", color: "bg-amber-500" },
    { name: "Fresh Coat Painters", tag: "Painting", rating: "5.0", jobs: 98, response: "~25 min", color: "bg-teal-500" },
];

const CATEGORIES = ["Plumbing", "Electrical", "Cleaning", "Moving"];

export default function PhoneMockup({ className = "" }) {
    return (
        <div
            data-testid="servicenext-phone-mockup"
            className={`relative mx-auto w-[260px] overflow-hidden rounded-[2.6rem] border-[10px] border-slate-900 bg-slate-50 shadow-[0_30px_80px_-20px_rgba(15,23,42,0.35)] ${className}`}
        >
            <div className="absolute left-1/2 top-2.5 z-10 h-5 w-20 -translate-x-1/2 rounded-full bg-slate-900" />
            <div className="px-4 pb-5 pt-11">
                <div className="flex items-center justify-between">
                    <p className="text-sm font-extrabold tracking-tight text-slate-900">ServiceNext</p>
                    <span className="flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-0.5 text-[9px] font-semibold text-emerald-700">
                        <MapPin className="h-2.5 w-2.5" /> Calgary
                    </span>
                </div>
                <div className="mt-3 flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-2">
                    <Search className="h-3.5 w-3.5 text-slate-400" />
                    <span className="text-[11px] text-slate-400">What do you need done?</span>
                </div>
                <div className="mt-3 flex gap-1.5 overflow-hidden">
                    {CATEGORIES.map((c, i) => (
                        <span
                            key={c}
                            className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[9px] font-semibold ${
                                i === 0 ? "bg-slate-900 text-white" : "bg-white text-slate-600 border border-slate-200"
                            }`}
                        >
                            {c}
                        </span>
                    ))}
                </div>
                <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-400">
                    Verified pros near you
                </p>
                <div className="mt-2 space-y-2.5">
                    {PROVIDERS.map((p) => (
                        <div key={p.name} className="rounded-2xl border border-slate-200 bg-white p-3 shadow-sm">
                            <div className="flex items-center gap-2.5">
                                <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[11px] font-bold text-white ${p.color}`}>
                                    {p.name.charAt(0)}
                                </span>
                                <div className="min-w-0">
                                    <p className="truncate text-[11px] font-bold text-slate-900">{p.name}</p>
                                    <p className="text-[9px] text-slate-500">{p.tag}</p>
                                </div>
                                <span className="ml-auto flex items-center gap-0.5 text-[10px] font-bold text-slate-900">
                                    <Star className="h-3 w-3 fill-amber-400 text-amber-400" />
                                    {p.rating}
                                </span>
                            </div>
                            <div className="mt-2 flex items-center gap-3 text-[9px] text-slate-500">
                                <span className="flex items-center gap-1">
                                    <CheckCircle2 className="h-3 w-3 text-emerald-500" /> {p.jobs} jobs
                                </span>
                                <span className="flex items-center gap-1">
                                    <Clock className="h-3 w-3 text-blue-500" /> {p.response}
                                </span>
                                <span className="ml-auto flex items-center gap-1 rounded-full bg-slate-900 px-2 py-1 font-semibold text-white">
                                    <MessageCircle className="h-2.5 w-2.5" /> Chat
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
